<div class="view-month" *ngIf="viewMode === 'Mês'">
  <div class="month-header">
    <p *ngFor="let wDay of weekDays">{{ wDay }}</p>
  </div>
  <div class="month-weeks">
    <div class="week" *ngFor="let week of viewMonth.weeks; let weekIdx = index">
      <div id="view-day-{{weekDayIdx}}" class="day" *ngFor="let weekDay of week.days; let weekDayIdx = index" (click)="createNewMark(weekDay)">
        <p [ngClass]="{'gray': weekDay.notActive, 'green-bold': isToday(weekDay)}">{{ weekDay.day }}</p>
        <ng-container *ngIf="weekDay.special">
          <div id="day-special-{{daySpecial}}" class="mark special" *ngFor="let s of weekDay.special; let daySpecial = index">
            <span>{{ s.description }}</span>
          </div>
        </ng-container>
        <div id="day-mark-{{dayMark}}" class="mark {{ m.type }}" *ngFor="let m of weekDay.marks; let dayMark = index" (click)="openMarkModal($event, m)">
          <span>{{ m.hourStart }} {{ m.type | titlecase }} - {{ m.facName ? 'Cliente' : m.title | titlecase }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="view-week" *ngIf="viewMode === 'Semana'">
  <div class="week-header" [style.height.px]="headerHeightCalc">
    <div *ngFor="let wDay of weekDays; let idx = index" class="day-cell">
      <div class="arrow" *ngIf="isToday(viewMonth.weeks[viewWeekIdx].days[idx])">
        <svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 9L0.339745 0.749998L17.6603 0.75L9 9Z" fill="#00866E"/>
        </svg>
      </div>
      <div class="day-title">
        <p [ngClass]="{'gray': viewMonth.weeks[viewWeekIdx].days[idx].notActive, 'green-bold': isToday(viewMonth.weeks[viewWeekIdx].days[idx])}">{{ wDay }}</p>
        <p [ngClass]="{'gray': viewMonth.weeks[viewWeekIdx].days[idx].notActive, 'green-bold': isToday(viewMonth.weeks[viewWeekIdx].days[idx])}">{{ viewMonth.weeks[viewWeekIdx].days[idx].day }}</p>
      </div>
      <ng-container *ngIf="viewMonth.weeks[viewWeekIdx].days[idx].special">
        <div id="day-special-{{daySpecial}}" class="special" *ngFor="let s of viewMonth.weeks[viewWeekIdx].days[idx].special; let daySpecial = index">
          <span>{{ s.description }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="week-days">
    <div class="hour-axis">
      <div class="hour-axis-label" *ngFor="let hour of dayHours">
        <p id="axis-{{hour}}">{{ hour }}</p>
      </div>
    </div>
    <div id="view-day-{{dayIdx}}" class="day" *ngFor="let day of viewMonth.weeks[viewWeekIdx].days; let dayIdx = index" (click)="createNewMark(day)">
      <div id="{{dayIdx}}-{{hour}}" class="day-hour" *ngFor="let hour of dayHours"></div>
      <div
        id="day-mark-{{dayMark}}"
        class="mark {{ m.type }}"
        [style.top.px]="calcMarkYpos(m.hourStart)"
        [style.height.px]="calcMarkYsize(m.hourStart, m.hourEnd)"
        *ngFor="let m of day.marks; let dayMark = index"
        (click)="openMarkModal($event, m)"
      >
        <span>{{ m.hourStart }} {{ m.type | titlecase }} - {{ m.facName ? 'Cliente' : m.title | titlecase }}</span>
      </div>
    </div>
    <div id="hour-line" class="hour-line" [style.top.px]="calcLineYpos">
      <div class="line"></div>
      <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 7L3.82708e-07 13.0622L9.12681e-07 0.937822L9 7Z" fill="#F00000"/>
      </svg>
    </div>
  </div>
</div>

<div class="view-day" *ngIf="viewMode === 'Dia'">
  <div class="day-header" [style.height.px]="headerHeightCalc">
    <div class="day-cell">
      <div class="day-title">
        <p>{{  weekDays[viewDayIdx] }}</p>
        <p>{{ viewMonth.weeks[viewWeekIdx].days[viewDayIdx].day }}</p>
      </div>
      <ng-container *ngIf="viewMonth.weeks[viewWeekIdx].days[viewDayIdx].special">
        <div id="day-special-{{daySpecial}}" class="special" *ngFor="let s of viewMonth.weeks[viewWeekIdx].days[viewDayIdx].special; let daySpecial = index">
          <span>{{ s.description }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="day">
    <div class="hour-axis">
      <div class="hour-axis-label" *ngFor="let hour of dayHours">
        <p id="axis-{{hour}}">{{ hour }}</p>
      </div>
    </div>
    <div id="view-day-return" class="day-column" (click)="createNewMark()">
      <div id="return-{{hour}}" class="day-hour" *ngFor="let hour of dayHours"></div>
      <div
        id="day-mark-return"
        class="mark {{ m.type }}"
        [style.top.px]="calcMarkYpos(m.hourStart)"
        [style.height.px]="calcMarkYsize(m.hourStart, m.hourEnd)"
        [style.display]="m.type === 'retorno' ? 'flex' : 'none'"
        *ngFor="let m of viewMonth.weeks[viewWeekIdx].days[viewDayIdx].marks; let dayMark = index"
        (click)="openMarkModal($event, m)"
      >
        <span>{{ m.hourStart }} {{ m.type | titlecase }} - {{ m.facName ? 'Cliente' : m.title | titlecase }}</span>
      </div>
    </div>
    <div id="view-day-return" class="day-column" (click)="createNewMark()">
      <div id="visit-{{hour}}" class="day-hour" *ngFor="let hour of dayHours"></div>
      <div
        id="day-mark-visit"
        class="mark {{ m.type }}"
        [style.top.px]="calcMarkYpos(m.hourStart)"
        [style.height.px]="calcMarkYsize(m.hourStart, m.hourEnd)"
        [style.display]="m.type === 'visita' ? 'flex' : 'none'"
        *ngFor="let m of viewMonth.weeks[viewWeekIdx].days[viewDayIdx].marks; let dayMark = index"
        (click)="openMarkModal($event, m)"
      >
        <span>{{ m.hourStart }} {{ m.type | titlecase }} - {{ m.facName ? 'Cliente' : m.title | titlecase }}</span>
      </div>
    </div>
    <div id="view-day-return" class="day-column" (click)="createNewMark()">
      <div id="other-{{hour}}" class="day-hour" *ngFor="let hour of dayHours"></div>
      <div
        id="day-mark-other"
        class="mark {{ m.type }}"
        [style.top.px]="calcMarkYpos(m.hourStart)"
        [style.height.px]="calcMarkYsize(m.hourStart, m.hourEnd)"
        [style.display]="(m.type !== 'retorno' && m.type !== 'visita') ? 'flex' : 'none'"
        *ngFor="let m of viewMonth.weeks[viewWeekIdx].days[viewDayIdx].marks; let dayMark = index"
        (click)="openMarkModal($event, m)"
      >
        <span>{{ m.hourStart }} {{ m.type | titlecase }} - {{ m.facName ? 'Cliente' : m.title | titlecase }}</span>
      </div>
    </div>
    <div id="hour-line" class="hour-line" [style.top.px]="calcLineYpos">
      <div class="line"></div>
      <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 7L3.82708e-07 13.0622L9.12681e-07 0.937822L9 7Z" fill="#F00000"/>
      </svg>
    </div>
  </div>
</div>

<div class="view-cards" *ngIf="viewMode === 'Resultados'">
  <div id="mock-card-0" class="card-item" [ngClass]="{'off': !ap.facColor, 'green': ap.facColor === 1, 'red': ap.facColor === 2, 'yellow': ap.facColor === 3 }" *ngFor="let ap of searchFilterResults; let idx = index">
    <div class="left">
      <div class="day-header">
        <span class="bold-day">{{ ap.day }}&nbsp;</span>
        <span class="notmob">{{ shortMonth(ap.month) }}. de {{ ap.year }}</span>
        <span class="ismob">/{{ ap.month > 9 ? '' : 0 }}{{ ap.month }}/{{ shortYear(ap.year) }}</span>
      </div>
      <div class="info">
        <p id="info-name-{{idx}}">{{ ap.facName ? ap.facName : ap.title }}</p>
        <span id="info-hour-{{idx}}">{{ ap.hourStart }}{{ ap.hourEnd ? ' até ' + ap.hourEnd : '' }}</span>
      </div>
    </div>
    <div class="tag {{ ap.type }}">
      <div id="info-type-{{idx}}" class="tag-item"><span>{{ ap.type | uppercase }}</span></div>
    </div>
  </div>
</div>
